import gsap from "gsap";
import PrevalenceSorter from "../classes/sort/prevalenceSorter";
import SortPool from "../classes/sort/sortPool";
import Toggle from "../classes/toggle";
import convertRemToPixels from "../helpers/remConverter";
import * as GLOBALS from '../globals';

export default function InitServiceSelector() {
	const servicesSelectors = document.querySelectorAll(".bard__module.services_selector");
	if (servicesSelectors.length === 0) return;

	servicesSelectors.forEach((servicesSelector, index) => {
		const serviceCards = servicesSelector.querySelectorAll(".card.service");
		let serviceEntriesPool = servicesSelector.querySelector(".result-pool");
		let serviceEntries = serviceEntriesPool.querySelectorAll(".image-text");
		if (serviceCards.length !== serviceEntries.length) return servicesSelector.remove();

		let prevalenceSorter = new PrevalenceSorter(Array.from(serviceCards)[0].dataset.slug);
		const serviceEntriesSorter = new SortPool(serviceEntriesPool, prevalenceSorter);

		serviceCards.forEach((serviceCard) => {
			const serviceSlug = serviceCard.dataset.slug;

			const serviceCardToggle = new Toggle(serviceCard, (event) => {
				updateServiceCards(serviceCards, serviceCard);
				prevalenceSorter.setPrevalentSlug(serviceSlug);
				serviceEntriesSorter.update();

				setTimeout(() => {
					const bodyRect = document.body.getBoundingClientRect();
					const poolRect = serviceEntriesPool.getBoundingClientRect();
					const scrollMarginTop = convertRemToPixels((window.innerWidth >= GLOBALS.BREAKPOINT_LG ? 6 : 3.5) + 5)
					window.scrollTo({
						top: poolRect.top - bodyRect.top - scrollMarginTop,
						behavior: 'smooth'
					});
				}, 0);
			});

			let gotoHashstring = () => {
				const anchorid = window.location.hash.substring(1);

				if (anchorid != null && anchorid === serviceSlug) serviceCardToggle.toggle();
			};

			window.addEventListener("hashchange", gotoHashstring);
			gotoHashstring();
		});
	});
}

function updateServiceCards(pool, except) {
	pool.forEach((serviceCard) => {
		if (!serviceCard.toggleObject) return serviceCard.setAttribute("aria-pressed", "false");

		if (serviceCard !== except) serviceCard.toggleObject.pressed(false);
		else serviceCard.toggleObject.pressed(true);
	});
}
